const state = {
  mainFeatures: [],
  mainFeature: {},
};

export default state;
